"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = void 0;
const setCookie = (name, value, days) => {
    const domain = process.env.NEXT_PUBLIC_DOMAIN;
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `expires=${date.toUTCString()}`;
    }
    if (domain) {
        document.cookie = `${name}=${value}; ${expires}; path=/; domain=${domain};`;
    }
    else {
        document.cookie = `${name}=${value}; ${expires}; path=/;`;
    }
};
exports.setCookie = setCookie;
//# sourceMappingURL=cookies.js.map